import React from 'react'
import Obfuscate from 'react-obfuscate'

const CVHeader = ({
  name,
  label,
  location,
  email,
  phone,
  website,
  profiles,
}) => (
  <header className="header">
    <h1>{name.toUpperCase()}</h1>
    <h3 className="label">{label.toUpperCase()}</h3>
    <div className="contact-header">
      {location.city}, {location.countryCode}
    </div>
    <div id="contact">
      <br />
      <div className="contact-header">
        EMAIL <span className="responsive-hidden">•</span>{' '}
        <span className="responsive-show">
          <br />
        </span>
        <Obfuscate email={email} />{' '}
        <span className="responsive-show">
          <br />
          <br />
        </span>
      </div>
      <div className="contact-header">
        WEBSITE <span className="responsive-hidden">•</span>{' '}
        <span className="responsive-show">
          <br />
        </span>
        <a href={website}>{website}</a>{' '}
        <span className="responsive-show">
          <br />
          <br />
        </span>
      </div>
    </div>
    <br />
    <div id="profiles">
      <div className="contact-header">PROFILES</div>
      {profiles &&
        profiles.map(({ network, username, url }) => (
          <p key={network} className="profile" style={{ textAlign: 'center' }}>
            <a href={url} target="_blank" className="profile">
              {network}
            </a>
          </p>
        ))}
      <br />
    </div>
  </header>
)

export default CVHeader



// WEBPACK FOOTER //
// ./src/components/cv/CVHeader.js